var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0846 56.4092V64.4258C64.0846 71.1858 57.7796 76.6675 50.0013 76.6675C42.223 76.6675 35.918 71.1858 35.918 64.4258V56.4092C35.918 63.1692 42.223 68.0008 50.0013 68.0008C57.7796 68.0008 64.0846 63.1692 64.0846 56.4092Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0846 65V73.0167C64.0846 79.7767 57.7796 85.2583 50.0013 85.2583C42.223 85.2583 35.918 79.7767 35.918 73.0167V65C35.918 71.76 42.223 76.5917 50.0013 76.5917C57.7796 76.5917 64.0846 71.76 64.0846 65Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0846 45.5747V56.408C64.0846 63.168 57.7796 67.9997 50.0013 67.9997C42.223 67.9997 35.918 63.168 35.918 56.408V45.5747C35.918 38.8147 42.223 33.333 50.0013 33.333C53.9013 33.333 57.4113 34.698 59.968 36.908C62.503 39.1397 64.0846 42.1947 64.0846 45.5747Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0846 45.5747C64.0846 47.5463 63.543 49.3663 62.5896 50.9263C60.2713 54.7397 55.5046 57.1663 50.0013 57.1663C44.498 57.1663 39.7313 54.7397 37.413 50.9263C36.4596 49.3663 35.918 47.5463 35.918 45.5747C35.918 42.1947 37.4996 39.1397 40.0346 36.9297C42.5913 34.698 46.1013 33.333 50.0013 33.333C53.9013 33.333 57.4113 34.698 59.968 36.908C62.503 39.1397 64.0846 42.1947 64.0846 45.5747Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3317 86.5138C61.1644 87.4615 63.3026 88 65.619 88L69.5 88L70.5 60.0003C70.5 60.0003 69.5899 60 65.619 60C63.3026 60 61.1644 60.5385 59.3317 61.4862C54.8517 63.7908 52.0008 68.5292 52.0008 74C52.0008 79.4708 54.8517 84.2092 59.3317 86.5138Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6182 88C67.3018 88 65.1636 87.4615 63.3309 86.5138C58.8509 84.2092 56 79.4708 56 74C56 68.5292 58.8509 63.7908 63.3309 61.4862C65.1636 60.5385 67.3018 60 69.6182 60C73.5891 60 77.1782 61.5723 79.7745 64.0923C82.3964 66.6338 84 70.1231 84 74C84 77.8769 82.3964 81.3662 79.8 83.9077C77.1782 86.4277 73.5891 88 69.6182 88Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 55.6405L16.0016 54.7071C15.6198 54.5798 15.0258 54.6647 14.7005 54.9051L12.7277 56.3123C11.462 57.2103 10.4296 56.687 10.4296 55.1314L10.4296 52.5009C10.4296 52.0625 10.1256 51.5039 9.74372 51.2635L7.73551 50.0049C6.15159 49.0149 6.33544 47.827 8.14564 47.3603L10.67 46.7168C11.1296 46.5966 11.5963 46.1299 11.7165 45.6703L12.36 43.1459C12.8267 41.3357 14.0146 41.1519 15.0046 42.7358L16.2632 44.744C16.4966 45.1188 17.0552 45.4228 17.5007 45.4299L20.1311 45.4299C21.6867 45.4299 22.2171 46.4693 21.312 47.728L19.9048 49.7008C19.6715 50.0331 19.5796 50.62 19.7068 51.0019L20.6402 53.802C21.1493 55.3152 20.315 56.1496 18.8018 55.6405Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3354 49.8491L28.2852 54.7988",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.851 58.3344L19.8008 63.2842",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6288 57.6278L24.043 59.042",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4483 23.2486L72.6025 19.7862C72.7599 19.3141 72.6549 18.5796 72.3577 18.1774L70.6177 15.738C69.5073 14.1729 70.1543 12.8964 72.0779 12.8964L75.3304 12.8963C75.8725 12.8963 76.5633 12.5204 76.8606 12.0482L78.4169 9.56506C79.641 7.60652 81.1099 7.83385 81.6869 10.0722L82.4826 13.1936C82.6313 13.762 83.2083 14.339 83.7766 14.4876L86.8981 15.2833C89.1364 15.8604 89.3638 17.3293 87.4052 18.5534L84.922 20.1097C84.4586 20.3982 84.0827 21.089 84.0739 21.6398L84.0739 24.8924C84.0739 26.816 82.7886 27.4718 81.2323 26.3526L78.7929 24.6126C78.3819 24.3241 77.6562 24.2104 77.1841 24.3678L73.7216 25.5219C71.8505 26.1515 70.8188 25.1198 71.4483 23.2486Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6087 28.8532L72.4883 34.9736",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1165 18.361L61.9961 24.4814",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9909 27.9788L67.2422 29.7275",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyLogo);
export default __webpack_public_path__ + "static/media/moneyLogo.1271d7e5dd85747a6c6f0e959122d055.svg";
export { ForwardRef as ReactComponent };